module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#t2",
      "id": "c2"
    }
  }, [_c('i', [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("As a disclaimer, I know there are more stories out there and more books that will probably never see the light of day. Country Music singer Bill Anderson, the long-ago Country Music Association Entertainer of the Year, suggested to my agent, Stan Cooper, that a single book could never contain all the stories about Merle, and I think he’s right about that. It seems that everyone in the Nashville music business—especially the old-timers—has a Merle Kilgore story. That’s what made him legendary. If you hung around Merle long enough, you’d eventually have your own story to tell.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But you won’t find all those stories here. For that reason, I don’t claim that my version is the definitive Merle Kilgore story. All I can hope to do is give my own telling of it, a secondhand account through the eyes of his grandson. I should also point out that most of the stories in this book are Merle’s stories; I merely brought them all together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On that note, allow me to quote the title of an Elton John album: "), _c('i', [_vm._v("Don’t shoot me; I’m only the piano player")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fcb30fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/authors_note.vue
// module id = 72
// module chunks = 0